import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Form from "react-bootstrap/Form";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice, faEye } from "@fortawesome/free-solid-svg-icons";
import {
  titleCase,
  dateStringTimeConvert,
} from "../../Utils/titleCaseFunction";
import { CancelDialog } from "../../Utils/DeleteDialog";
import config from "../../Helpers/config";
import axios from "axios";
import { errorMessages } from "../../Helpers/ErrorMessages";
import { CustomPagination } from "../../Utils/Tables/CustomTable";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPaper,
} from "../../Utils/Tables/CustomTable";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import TableContainer from "@material-ui/core/TableContainer";
import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
import { history } from "../../Helpers/history";
import { formatAmount } from "../../Utils/formatNumbers";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { useSalesFilter } from "./CustomHooks/useSalesFilter";
import { InvoiceDateFilter } from "./InvoiceDateFilter";
import { LoadingGif } from "../../Utils/Loader";
import CustomDialog from "../../Utils/Dialog/CustomDialog";
import { ReusablePosTemplate } from "./ReusablePosTemplate";
import { useExcelReports, usePdfReports } from "./CustomHooks/useExcelReports";
import Textarea from "../../Utils/FormInputs/Textarea";
import Label from "../../Utils/FormInputs/Label";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import { usePrint } from "../../Utils/Template/usePrint";
import { formatDigits } from "../../Utils/formatAmount";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: "0.8em",
    height: "0.8em",
  },
  paid: {
    color: "#1d5dd3",
  },
  canceled: {
    color: "#a30c0c",
  },
}));

const ManageInvoice = ({ actions, snackbars }) => {
  const classes = useStyles();

  const storage = JSON.parse(sessionStorage.getItem("total_count"));
  const item_count = storage ? storage : 0;
  const count = () => +item_count || 0;

  const [term, setTerm] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [invoice_id, setInvoiceId] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [total_Amount, setAmount] = useState(0);
  const [invoices, setInvoices] = useState([]);
  const [total_count, setTotalCount] = useState(count);
  const [loading, setLoading] = useState("idle"); // main list loading
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState("idle");

  const [openInvoice, setOpenInvoice] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [submit, setHasSubmitted] = useState(false);
  const [reason, setReason] = useState("");
  const [sale_type_detail, setSale_Type_Detail] = useState("");

  // New loading states
  const [loadingCancelPreview, setLoadingCancelPreview] = useState(false);     // preview loading
  const [loadingCancelOperation, setLoadingCancelOperation] = useState(false); // cancel / save draft operation

  const [data, setData] = useState({
    products: [],
    customer: {},
    loading: "idle",
  });

  const { handlePrint, componentRef, getPageMargins } = usePrint("");
  const { date, handleChange, filters } = useSalesFilter();
  const { filter_by, start_date, end_date } = date;

  useEffect(() => {
    setActivePage(1);
  }, [filter_by]);

  const retrieveInvoices = useCallback(
    (start_date = "", end_date, page = activePage) => {
      const isCustom = filter_by === "custom" ? { start_date, end_date } : {};
      setLoading("loading");
      axios
        .get(`${config.epharmUrl}/Cinvoice/invoices`, {
          params: {
            category: "invoices",
            time_filter: filter_by,
            page_number: page,
            search: term,
            ...isCustom,
          },
        })
        .then((response) => {
          const res = response.data;
          const dt = res.data || {};
          const arr = dt.invoices || {};
          const invoicesArr = arr.invoice_list || [];
          const t_amount = arr.grand_total_amount || 0;
          const total_amount = arr.total_amount || 0;
          const t_count = dt.total_records || 0;

          if (activePage === 1) {
            sessionStorage.setItem("total_count", JSON.stringify(t_count));
            setTotalCount(t_count);
          } else {
            setTotalCount(count);
          }

          setInvoices(invoicesArr);
          setTotalAmount(t_amount);
          setAmount(total_amount);
          setLoading("success");
        })
        .catch((error) => {
          errorMessages(error, null, actions);
          setLoading("error");
        });
    },
    [activePage, filter_by, term]
  );

  useEffect(() => {
    if (filter_by === "custom" && isSubmitted !== "resolved") return;
    retrieveInvoices(start_date, end_date);
  }, [retrieveInvoices, filter_by, start_date, end_date, isSubmitted]);

  const handler = (event) => setTerm(event.target.value);

  const handleFilter = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (start_date && end_date && start_date <= end_date) {
      setIsSubmitted("resolved");
      retrieveInvoices(start_date, end_date);
    }
  };

  const handleOpenInvoice = (invoice_number, cus_id, sale_typs) => {
    setSale_Type_Detail(sale_typs);
    setInvoiceId(invoice_number);
    setOpenInvoice(true);

    setLoadingCancelPreview(true);
    setData((prev) => ({ ...prev, loading: "loading" }));

    const formData = new FormData();
    formData.append("receipt_number", "");
    formData.append("invoice_number", invoice_number);
    formData.append("customer_id", cus_id);

    axios
      .post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then((response) => {
        const dataRes = response.data || {};
        const arr = dataRes.bill || [];
        const customer_details = dataRes.customer_details || {};
        const obj = arr[0] || {};

        setData({
          products: arr,
          customer: { ...customer_details, ...obj },
          loading: "success",
        });
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setData((prev) => ({ ...prev, loading: "error" }));
      })
      .finally(() => {
        setLoadingCancelPreview(false);
      });
  };

  const handleOpenPrint = (invoice_number, customer_id) => {
    const formData = new FormData();
    formData.append("receipt_number", "");
    formData.append("invoice_number", invoice_number);
    formData.append("customer_id", customer_id);

    setData((prev) => ({ ...prev, loading: "loading" }));

    axios
      .post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then((response) => {
        const dataRes = response.data || {};
        const arr = dataRes.bill || [];
        const customer_details = dataRes.customer_details || {};
        const obj = arr[0] || {};

        setData({
          products: arr,
          customer: { ...customer_details, ...obj },
          loading: "success",
        });
        handlePrint();
      })
      .catch((error) => {
        errorMessages(error, null, actions);
      });
  };

  const handleDelete = (is_draft = false) => {
    if (!reason.trim()) return;

    setLoadingCancelOperation(true);

    axios
      .post(`${config.epharmUrl}/Cinvoice/cancel_invoice`, {
        invoice_number: invoice_id,
        reason: reason.trim(),
      })
      .then(() => {
        actions.snackbarActions.successSnackbar(
          is_draft ? "Saved as draft successfully" : "Invoice canceled successfully"
        );

        setReason("");
        setOpenDialog(false);
        setOpenInvoice(false);
        setOpenConfirmation(false);
        setSale_Type_Detail("");

        if (is_draft) {
          sessionStorage.setItem(invoice_id, JSON.stringify(data));
          const path =
            sale_type_detail === "retail"
              ? `/createinvoice/new-invoice/${invoice_id}`
              : `/create-WholeSale-invoice/${invoice_id}/${sale_type_detail}`;
          history.push(path);
        }
      })
      .catch((error) => {
        errorMessages(error, null, actions);
      })
      .finally(() => {
        setLoadingCancelOperation(false);
        setHasSubmitted(false);
      });
  };

  const handleOpenConfirmation = () => {
    setHasSubmitted(true);
    if (reason.trim()) {
      setOpenConfirmation(true);
    }
  };

  const handleSaveDraft = () => handleDelete(true);
  const handleCancelInvoice = () => handleDelete(false);

  const handleCloseInvoice = () => setOpenInvoice(false);
  const handleCloseConfirmation = () => setOpenConfirmation(false);
  const handleCloseDialog = () => setOpenDialog(false);

  const handlePageChange = (pageNumber) => setActivePage(pageNumber);

  const { products, customer, loading: loadingInvoice } = data;

  const isLoading = loading === "loading";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const isLoadingInvoice =
    loadingInvoice === "loading" || loadingCancelPreview;

  const isSuccessInvoice = loadingInvoice === "success" && !loadingCancelPreview;

  const { exportExcel } = useExcelReports(actions, {
    file_name: "Invoices",
    url: "Cinvoice/manage_sales_excel_report",
    params: {
      category: "invoices",
      time_filter: filter_by,
      ...(filter_by === "custom" ? { start_date, end_date } : {}),
    },
  });

  const { exportPDF } = usePdfReports(actions, {
    file_name: "Invoices pdf",
    url: "Cinvoice/manage_sales_pdf_report",
    params: {
      download: true,
      category: "invoices",
      time_filter: filter_by,
      ...(filter_by === "custom" ? { start_date, end_date } : {}),
    },
  });

  const handleExcelExport = () => {
    if (!invoices?.length) {
      actions.snackbarActions.errorSnackbar("There are no records to download");
      return;
    }
    exportExcel();
  };

  const headData = [
    { id: "sl", numeric: false, disablePadding: false, label: "Sl" },
    { id: "invoice", numeric: false, disablePadding: false, label: "Invoice#" },
    { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
    { id: "date", numeric: false, disablePadding: false, label: "Date" },
    { id: "sale_type", numeric: false, disablePadding: false, label: "Sale Type" },
    { id: "total", numeric: false, disablePadding: false, label: "Total Amount" },
    { id: "amount_due", numeric: false, disablePadding: false, label: "Amount Due" },
    { id: "action", numeric: false, disablePadding: false, label: "Action" },
  ];

  const components = [
    { label: "Receipts", path: "/sales-receipts" },
    { label: "Invoices", path: "/manageinvoice" },
    { label: "Cancelled Sales", path: "/cancelledsales" },
  ];

  const buttons = (
    <>
      <button
        className="btn pharmacy-info-btn btn-sm mr-3"
        onClick={() => setOpenDialog(true)}
      >
        Continue
      </button>
      <button
        className="btn pharmacy-grey-btn btn-sm"
        onClick={handleCloseInvoice}
      >
        No
      </button>
    </>
  );

  const reasonForm = (
    <Form.Group>
      <Label name="Please enter reason for cancelling invoice" type />
      <Textarea
        type="text"
        placeholder="please type reason here..."
        name="Reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        submitted={submit}
      />
      {submit && !reason && (
        <div className="invalid-text">Please enter a reason</div>
      )}
    </Form.Group>
  );

  return (
    <div data-testid="manage_invoice">
      <ReusableDashboardHeader
        component="Manage Sales"
        heading="Sales"
        subHeading="Invoices"
        link="/manageinvoice"
      />

      {/* Full-screen loader during cancel or save-as-draft */}
      {loadingCancelOperation && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div className="text-center text-white">
            <LoadingGif />
            <p className="mt-3 fs-5">
              Please wait... {openConfirmation ? "Saving as draft" : "Cancelling invoice"}
            </p>
          </div>
        </div>
      )}

      <div className="receipt-container">
        <ReusableRouteTabs
          value={history.location.pathname}
          tabHeading={components}
        />

        <PharmacySnackbar
          open={snackbars.open}
          message={snackbars.message}
          variant={snackbars.variant}
          handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
        />

        {/* Cancel Invoice Preview Dialog */}
        <CustomDialog
          maxWidth="md"
          title="Cancel Invoice"
          open={openInvoice}
          handleClose={handleCloseInvoice}
          buttons={buttons}
          isOverflow={false}
        >
          {isLoadingInvoice ? (
            <div className="text-center mt-5 mb-5">
              <LoadingGif />
              <p className="mt-3">Please wait... Loading invoice details</p>
            </div>
          ) : isSuccessInvoice ? (
            <ReusablePosTemplate {...{ customer, products }} />
          ) : (
            <div className="text-center mt-5">
              The server did not return a valid response
            </div>
          )}
        </CustomDialog>

        {/* Reason Dialog */}
        <CancelDialog
          openDialog={openDialog}
          handleClose={handleCloseDialog}
          heading="Cancel Invoice"
          message={reasonForm}
        >
          <button
            className="btn pharmacy-info-btn btn-sm mr-3"
            disabled={loadingCancelOperation}
            onClick={handleOpenConfirmation}
          >
            {loadingCancelOperation ? "Processing..." : "Cancel Invoice"}
          </button>
          <button
            className="btn pharmacy-grey-btn btn-sm"
            disabled={loadingCancelOperation}
            onClick={handleCloseDialog}
          >
            Don't Cancel Invoice
          </button>
        </CancelDialog>

        {/* Save as Draft Confirmation */}
        <CancelDialog
          openDialog={openConfirmation}
          handleClose={handleCloseConfirmation}
          heading="Use invoice as draft"
          message={
            loadingCancelOperation ? (
              <div className="text-center py-4">
                <LoadingGif />
                <p className="mt-3">Saving as draft... Please wait</p>
              </div>
            ) : (
              "Would you like to use this invoice as a draft?"
            )
          }
        >
          {loadingCancelOperation ? null : (
            <>
              <button
                className="btn pharmacy-info-btn btn-sm mr-3"
                onClick={handleSaveDraft}
              >
                Yes
              </button>
              <button
                className="btn pharmacy-grey-btn btn-sm"
                onClick={handleCancelInvoice}
              >
                No
              </button>
            </>
          )}
        </CancelDialog>

        <div style={{ display: "none" }}>
          <div ref={componentRef} className="card styled-pos-card">
            {getPageMargins}
            <ReusablePosTemplate {...{ customer, products }} />
          </div>
        </div>

        <div className="my-3">
          <InvoiceDateFilter
            {...{ filters, date, handleChange, handleFilter, submitted }}
          />
        </div>

        <MuiPaper>
          <EnhancedTableToolbar title="Invoices">
            <span className="btn-group" style={{ flex: "1 1 100%" }}>
              <button
                onClick={handleExcelExport}
                className="btn pharmacy-btn mr-1 btn-sm"
              >
                Download Excel
              </button>
              <button
                onClick={exportPDF}
                className="btn pharmacy-btn mr-1 btn-sm"
              >
                Download PDF
              </button>
            </span>
            <Form.Control
              type="text"
              value={term ? titleCase(term) : ""}
              data-testid="search_list"
              onChange={handler}
              className="form__control"
              placeholder="Search"
              style={{ float: "right" }}
            />
          </EnhancedTableToolbar>

          <div className="sub-journal-bar" style={{ marginLeft: "0" }}>
            <h6 data-testid="total_receipts">
              Total Invoices : <strong>{formatDigits(total_count)}</strong>
            </h6>
            <h6 data-testid="running_balance">
              Total Amount : <strong>{formatAmount(totalAmount)}</strong>
            </h6>
          </div>

          <TableContainer>
            <Table aria-label="enhanced table" size="medium">
              <EnhancedTableHead headCells={headData} />

              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      <LoadingGif />
                    </TableCell>
                  </TableRow>
                ) : isSuccess ? (
                  invoices.length > 0 ? (
                    <>
                      {invoices.slice(0, 10).map((info, index) => {
                        const sl = (activePage - 1) * 10 + index + 1;

                        const saleTypeStyles = {
                          wholesale: { backgroundColor: "#d1fae5", color: "#065f46" },
                          retail: { backgroundColor: "#dbeafe", color: "#1e40af" },
                        };

                        const saleTypeLabels = {
                          wholesale: "Facility",
                          retail: "Client",
                        };

                        return (
                          <TableRow hover key={index}>
                            <TableCell>{sl}</TableCell>
                            <TableCell>{info.invoice_number}</TableCell>
                            <TableCell>{titleCase(info.customer_name)}</TableCell>
                            <TableCell>
                              {info.date ? dateStringTimeConvert(info.date) : ""}
                            </TableCell>
                            <TableCell>
                              <span
                                style={{
                                  ...saleTypeStyles[info.sale_type?.toLowerCase()],
                                  padding: "4px 10px",
                                  borderRadius: "9999px",
                                  fontWeight: "600",
                                  fontSize: "0.875rem",
                                  display: "inline-block",
                                }}
                              >
                                {saleTypeLabels[info.sale_type?.toLowerCase()] || info.sale_type}
                              </span>
                            </TableCell>
                            <TableCell>{formatAmount(info.total_amount)}</TableCell>
                            <TableCell>{formatAmount(info.due_amount)}</TableCell>
                            <TableCell>
                              <Tooltip title="View Thermal POS Invoice (Compact)" placement="top">
                                <Link to={`/invoice_print/${info.customer_id}/${info.invoice_number}`}>
                                  <button className="btn btn-sm btn-info mr-2 icon-button-holder">
                                    <VisibilityIcon className={classes.icon} /> Thermal
                                  </button>
                                </Link>
                              </Tooltip>

                              <Tooltip title="View Full A4 POS Invoice" placement="top">
                                <Link to={`/invoice_print_big/${info.customer_id}/${info.invoice_number}`}>
                                  <button className="btn btn-sm btn-primary icon-button-holder mr-2">
                                    <FontAwesomeIcon icon={faFileInvoice} /> Full A4
                                  </button>
                                </Link>
                              </Tooltip>

                              <Tooltip title="Print">
                                <button
                                  type="button"
                                  onClick={() => handleOpenPrint(info.invoice_number, info.customer_id)}
                                  className="btn btn-sm pharmacy-gray-btn icon-button-holder mb-sm-2"
                                >
                                  <PrintOutlinedIcon classes={{ root: classes.icon }} />
                                </button>
                              </Tooltip>

                              <Tooltip title="Cancel Invoice" placement="left-start">
                                <button
                                  data-testid={`cancel_sale-${index}`}
                                  onClick={() => handleOpenInvoice(info.invoice_number, info.customer_id, info.sale_type)}
                                  className="btn btn-sm pharmacy-gray-btn icon-button-holder mb-sm-2"
                                >
                                  <CloseIcon className={classes.icon} />
                                </button>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })}

                      <TableRow>
                        <TableCell colSpan={5} className="text-right" style={{ fontWeight: "700" }}>
                          Total Amount Per Page:
                        </TableCell>
                        <TableCell style={{ fontWeight: "700" }}>
                          {formatAmount(total_Amount)}
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={headData.length} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  )
                ) : isError ? (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      The server did not return a valid response
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>

            <CustomPagination
              data={invoices}
              records={10}
              activePage={activePage}
              total_count={total_count}
              handleChangeNextPage={handlePageChange}
            />
          </TableContainer>
        </MuiPaper>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    snackbars: state.snackbars,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageInvoice);